import { useState } from 'react'
import './PhotoLightbox.css'

interface PhotoLightboxProps {
  images: string[]
  source?: 'marketplace' | 'stock' | null
  onClose: () => void
}

export default function PhotoLightbox({ images, source, onClose }: PhotoLightboxProps) {
  const [currentIndex, setCurrentIndex] = useState(0)

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1))
  }

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1))
  }

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const getSourceLabel = (): string => {
    switch (source) {
      case 'marketplace':
        return 'From marketplace listing'
      case 'stock':
        return 'Professional stock photo'
      default:
        return 'Vehicle photo'
    }
  }

  return (
    <div className="lightbox-backdrop" onClick={handleBackdropClick}>
      <div className="lightbox-container">
        <button className="lightbox-close" onClick={onClose} aria-label="Close">
          ✕
        </button>

        <div className="lightbox-image-wrapper">
          <img
            src={images[currentIndex]}
            alt={`Vehicle photo ${currentIndex + 1}`}
            className="lightbox-image"
          />
        </div>

        {images.length > 1 && (
          <>
            <button className="lightbox-nav lightbox-prev" onClick={handlePrevious} aria-label="Previous">
              ‹
            </button>
            <button className="lightbox-nav lightbox-next" onClick={handleNext} aria-label="Next">
              ›
            </button>

            <div className="lightbox-counter">
              {currentIndex + 1} / {images.length}
            </div>

            <div className="lightbox-thumbnails">
              {images.map((img, index) => (
                <button
                  key={index}
                  className={`lightbox-thumbnail ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                >
                  <img src={img} alt={`Thumbnail ${index + 1}`} />
                </button>
              ))}
            </div>
          </>
        )}

        <div className="lightbox-source">{getSourceLabel()}</div>
      </div>
    </div>
  )
}
